//
// Module for the Retirement Setup wizard's Initiate step
//
rs.module("participant/benefit/setup/retirement/wizard/initiatestep",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, flags) {

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var separationTypeSelect = stepContainer.js(jsSelectors.separationTypeSelect, { required: false });
            var disabilityContainer = stepContainer.js(jsSelectors.disabilityContainer, { required: false });
            var disabilitySelect = stepContainer.js(jsSelectors.disabilitySelect, { required: false });
            var disabilitySelectHelper = selectHelper.getHelper(disabilitySelect);
            var separationDateInput = stepContainer.js(jsSelectors.separationDateInput, { required: false });
            var benefitEffectiveDateInput = stepContainer.js(jsSelectors.benefitEffectiveDateInput);
            var applyIncomeLevelingCheckBox = stepContainer.js(jsSelectors.applyIncomeLevelingCheckBox, { required: false });
            var socialSecurityBenefitAmountInput = stepContainer.js(jsSelectors.socialSecurityBenefitAmountInput, { required: false });
            var socialSecurityStartAgeInput = stepContainer.js(jsSelectors.socialSecurityStartAgeInput, { required: false });
            var socialSecurityEvidenceFiledCheckbox = stepContainer.js(jsSelectors.socialSecurityEvidenceFiledCheckbox, { required: false });
            var initiateOnlyCheckBox = stepContainer.js(jsSelectors.initiateOnlyCheckBox, { required: false });

            // On initialize of page, appropriately set wizard's next button text (Next or Finish)
            setWizardNextButtonText();

            // Conditionally set display of Wizard's next button text (Next or Finish) based on InitiateOnlyCheckBox
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on initiateOnlyCheckBox
                if (initiateOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            }

            // Hookup separationTypeSelect change event
            separationTypeSelect.change(separationTypeChange);

            // Hookup separationDateInput change event
            separationDateInput.change(_.debounce(function () { separationDateChange(); }, 500));

            // Enable/Disable Income Leveling fields on applyIncomeLevelingCheckBox change
            applyIncomeLevelingCheckBox.change(function () {

                // Enable/disable Income Leveling fields
                socialSecurityBenefitAmountInput.prop("disabled", !this.checked).val("").clearErrors();
                socialSecurityStartAgeInput.prop("disabled", !this.checked).val("").clearErrors();
                socialSecurityEvidenceFiledCheckbox.prop("disabled", !this.checked).prop('checked', false);
            });

            // Handle initiateOnlyCheckBox change
            initiateOnlyCheckBox.change(function () {

                // Set wizard's next button text (Next or Finish)
                setWizardNextButtonText();
            });

            // Separation Type change event
            function separationTypeChange() {

                // Get selected Separation Type
                var selectedSeparationType = separationTypeSelect.val();

                // Clear Disability selection errors
                disabilitySelect.clearErrors();

                // Enable/Disable dependent fields
                if (selectedSeparationType == codeValues.disabilityRetirement) {

                    disabilityContainer.show();
                }
                else {
                    disabilityContainer.hide();
                    disabilitySelectHelper.setValue("");
                }
            }

            // Separation Date change event
            function separationDateChange() {

                separationDateInput.clearErrors();

                if (separationDateInput.val() && separationDateInput.valid()) {

                    // Get entered Separation Date
                    var separationDate = separationDateInput.val();

                    // If the Separation Date was not system defaulted, populate Effective Date with Separation Date + 1 day
                    if (flags.isRecalc || !flags.separationDateDefaulted) {
                        var effectiveDate = new Date(separationDate);
                        effectiveDate.setDate(effectiveDate.getDate() + 1);
                        benefitEffectiveDateInput.val(new Date(effectiveDate).toISODateString()).clearErrors();
                    }
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);